import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import "./hero.css";

const Hero = () => {
  const heroRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: {
          ease: "power3.out",
        },
      });

      tl.from(".heading", {
        opacity: 0,
        y: 30,
        duration: 0.6,
      })

        .from(
          ".hero-description",
          {
            opacity: 0,
            y: 25,
            duration: 0.5,
          },
          "-=0.3"
        );
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={heroRef}
      className="herosection"
    >
      <h1 className="heading">
        Digital Transformation Through <span className="gradient-text">IT Solutions</span>{" "}
      </h1>

      <p className="subheading hero-description">
        We aspire to create a world where technology enhances
        lives, turning this vision into reality.
      </p>

    </section>
  );
};

export default Hero;